import { render, staticRenderFns } from "./ContractsNotices.vue?vue&type=template&id=656e2fac&scoped=true&"
import script from "./ContractsNotices.vue?vue&type=script&lang=js&"
export * from "./ContractsNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e2fac",
  null
  
)

export default component.exports